import type { Asset, Page } from '@oneaudi/falcon-tools';

export const DEFAULT_HEADLINE_TAG = 'h2';

export type ThemeType = 'Dark' | 'Light';
export type HeadlineTag = 'h1' | 'h2' | 'h3' | 'h4';
export type TeaserHeadlineTag = 'h2' | 'h3' | 'h4' | 'h5';
export type MaxColumnsType = '1' | '2' | '3' | '4';

// copied from fa-article-intro START
export type ArticleFormatType =
  | 'article'
  | 'interview'
  | 'report'
  | 'reportage'
  | 'short-format'
  | 'portrait'
  | 'car-presentation'
  | 'my-favorite-feature'
  | 'audi-e-tron-story';
// copied from fa-article-intro END

export interface ArticleIntroCF {
  __type: 'aem-headless';
  fields: {
    // copied from fa-article-intro START
    headline: string;
    copy: string;
    teaserLink?: Page;
    teaserLinkUrl?: string;
    teaserLinkLabel?: string;
    teaserLinkAriaLabel?: string;
    teaserImage?: Asset;
    teaserImageAlt?: string;
    teaserTextOverride?: string;
    teaserConsumptionAndEmissionsOverride?: string[];
    teaserDisclaimersOverride?: string[];
    articleID?: string;
    articleFormat?: ArticleFormatType;
    articleCredits?: string;
    articleReadingTime?: number;
    articleCreationDate?: string; // ISO 8601 date string
    consumptionAndEmissions?: string[];
    disclaimers?: string[];
    // copied from fa-article-intro END
    theme?: ThemeType;
  };
}

export interface FalconContent {
  __type: 'aem-headless';
  fields: {
    headline: string;
    headlineTag?: HeadlineTag;
    articleIntros?: ArticleIntroCF[];
    maxColumns?: MaxColumnsType;
    theme?: ThemeType;
  };
}

export interface ArticleIntro {
  // copied from fa-article-intro START
  headline: string;
  copy: string;
  teaserLink?: string;
  teaserLinkUrl?: string;
  teaserLinkLabel?: string;
  teaserLinkAriaLabel?: string;
  teaserImage?: string;
  teaserImageAlt?: string;
  teaserTextOverride?: string;
  teaserConsumptionAndEmissionsOverride?: string[];
  teaserDisclaimersOverride?: string[];
  articleID?: string;
  articleFormat?: ArticleFormatType;
  articleCredits?: string;
  articleReadingTime?: number;
  articleCreationDate?: string; // // ISO 8601 date string
  consumptionAndEmissions?: string[];
  disclaimers?: string[];
  // copied from fa-article-intro END
  theme: ThemeType;

  index: number; // additional prop
}

export interface AppContent {
  headline: string;
  headlineTag: HeadlineTag;
  articleIntros?: ArticleIntro[];
  maxColumns: number;
  theme: ThemeType;
}
